export class FormBuilderBasicInputModel {
    public type: string;

    public subtype?: string;

    public label: string;

    public content?: string;

    public mandatory: boolean = true;

    public options?: any[];

    public help?: string;

    public layout?: string;

    public columns?: number;

    public placeholder?: string;

    public placeholder2?: string;

    public characterCount?: number;

    public validation?: string;

    public commentBox?: boolean;

    public commentLabel?: string;

    public minChoice?: number;

    public maxChoice?: number;

    public contentHeadings?: any[];

    public contentRows?: any[];

    public active: boolean = false;

    constructor() {}

    mountWithValues(data: FormBuilderBasicInputModel): void {
        this.label = data.label;

        this.type = data.type;
        
        this.placeholder = data.placeholder;

        this.help = data.help;

        if (data.columns !== undefined) {
            this.columns = data.columns;
        }

        if (data.layout !== undefined) {
            this.layout = data.layout;
        }

        if (data.content !== undefined) {
            this.content = data.content;
        }

        if (data.contentHeadings !== undefined) {
            this.contentHeadings = data.contentHeadings;
        }

        if (data.contentRows !== undefined) {
            this.contentRows = data.contentRows;
        }

        if (data.subtype !== undefined) {
            this.subtype = data.subtype;
        }
    }

    mountWithDefaults({ label, type }): void {
        this.label = label;

        this.type = type;
        
        this.content = 'rich_text';

        switch (this.type) {
            case 'single_select':
                this.layout = 'horizontal';

                this.help = '';

                this.options = [
                    { 
                        image: '',
                        label: 'Option 1 label',
                        content: 'rich_text'
                    },
                    {
                        image: '',
                        label: 'Option 2 label',
                        content: 'rich_text'
                    },
                    {
                        image: '',
                        label: 'Option 3 label',
                        content: 'rich_text'
                    }
                ];
                break;
            case 'multi_select':
                this.layout = 'horizontal';

                this.help = '';

                this.minChoice = 0;

                this.maxChoice = 0;

                this.options = [
                    { 
                        image: '',
                        label: 'Option 1 label',
                        content: 'rich_text'
                    },
                    {
                        image: '',
                        label: 'Option 2 label',
                        content: 'rich_text'
                    },
                    {
                        image: '',
                        label: 'Option 3 label',
                        content: 'rich_text'
                    }
                ];
                break;
            case 'text_input':
                this.subtype = 'single_line';

                this.help = '';
                
                this.placeholder = '';

                this.characterCount = 0;

                this.validation = 'numeric|alpha|alphanumeric';
                break;
            case 'email_input':
                this.placeholder = '';

                this.help = '';
                break;
            case 'number_input':
                this.placeholder = '';

                this.help = '';
                break;
            case 'date_input':
                this.placeholder = 'DD/MM/YYYY';
                
                this.help = '';

                this.validation = 'DDMMYYYY';
                break;
            case 'date_from_and_to':
                this.placeholder = 'DD/MM/YYYY';

                this.placeholder2 = 'DD/MM/YYYY';
                
                this.help = '';
                
                this.validation = 'DDMMYYYY';
                break;
            case 'rate_input':
                this.help = '';

                this.characterCount = 5;

                this.commentBox = false;

                this.commentLabel = 'Comments';
                break;
            case 'checklist':
                this.columns = 2;

                this.layout = '50-50';

                this.help = '';

                this.contentHeadings = [ 
                    {
                        content: 'Column heading',
                        help: null
                    },
                    {
                        content: 'Column heading',
                        help: null
                    },
                    {
                        content: 'Column heading',
                        help: null
                    },
                    {
                        content: 'Column heading',
                        help: null
                    }
                ];

                this.contentRows = [
                    [
                        {
                            type: 'label',
                            content: 'Your text goes here'
                        },
                        {
                            type: 'text',
                            placeholder: 'Placeholder text'
                        },
                        {
                            type: 'label',
                            content: 'Your text goes here'
                        },
                        {
                            type: 'label',
                            content: 'Your text goes here'
                        }
                    ]
                ];
                break;
            case 'divider':
                this.subtype = 'solid';
                
                this.layout = 'thin';
                break;
        }
    }

    duplicateComponent(originalComponent: FormBuilderBasicInputModel): void {
        switch (this.type) {
            case 'p':
                this.content = originalComponent.content;
                break;
            case 'single_select':
                this.content = originalComponent.content;
                this.layout = originalComponent.layout;
                this.options = originalComponent.options;
                this.mandatory = originalComponent.mandatory;
                break;
            case 'text_input':
                this.content = originalComponent.content;
                this.subtype = originalComponent.subtype;
                this.characterCount = originalComponent.characterCount;
                this.placeholder = originalComponent.placeholder;
                this.help = originalComponent.help;
                this.mandatory = originalComponent.mandatory;
                break;
            case 'email_input':
                this.content = originalComponent.content;
                this.placeholder = originalComponent.placeholder;
                this.help = originalComponent.help;
                this.mandatory = originalComponent.mandatory;
                break;
            case 'date_input':
                this.content = originalComponent.content;
                this.placeholder = originalComponent.placeholder;
                this.help = originalComponent.help;
                this.mandatory = originalComponent.mandatory;
                break;
            case 'date_from_and_to':
                this.content = originalComponent.content;
                this.placeholder = originalComponent.placeholder;
                this.placeholder2 = originalComponent.placeholder2;
                this.help = originalComponent.help;
                this.mandatory = originalComponent.mandatory;
                break;
            case 'number_input':
                this.content = originalComponent.content;
                this.placeholder = originalComponent.placeholder;
                this.help = originalComponent.help;
                this.mandatory = originalComponent.mandatory;
                break;
            case 'rate_input':
                this.content = originalComponent.content;
                this.placeholder = originalComponent.placeholder;
                this.help = originalComponent.help;
                this.mandatory = originalComponent.mandatory;
                this.characterCount = originalComponent.characterCount;
                this.commentBox = originalComponent.commentBox;
                this.commentLabel = originalComponent.commentLabel;
                break;
            case 'multi_select':
                this.content = originalComponent.content;
                this.layout = originalComponent.layout;
                this.options = originalComponent.options;
                this.mandatory = originalComponent.mandatory;
                this.minChoice = originalComponent.minChoice;
                this.maxChoice = originalComponent.maxChoice;
                break;
            case 'checklist':
                this.content = originalComponent.content;
                this.layout = originalComponent.layout;
                this.columns = originalComponent.columns;
                this.mandatory = originalComponent.mandatory;
                this.help = originalComponent.help;
                this.contentHeadings = originalComponent.contentHeadings;
                this.contentRows = originalComponent.contentRows;
                break;
            case 'divider':
                this.subtype = originalComponent.subtype;
                this.layout = originalComponent.layout;
                break;
            default:
                break;
        }
    }
}
